function getHeadings(str) {
  const headingRegex = /<h([1-3])>(.+?)<\/h[1-3]>/gi;

  let matches = null;
  const headings = {};
  let currentHeading = null;
  let idCounter = 0;
  let htmlWithIds = str;

  while ((matches = headingRegex.exec(str))) {
    const level = parseInt(matches[1], 10);
    const text = matches[2].trim().replace(/<\/?[^>]+>/gi, '');
    const id = `heading-${++idCounter}`;

    const heading = { level, text: text.trim(), id, subheadings: [] };

    if (level === 2) {
      headings[id] = heading;
      currentHeading = heading;
    } else if (level === 3 && currentHeading) {
      currentHeading.subheadings.push(heading);
    }

    htmlWithIds = htmlWithIds.replace(
      matches[0],
      `<h${level} id="${id}">${text}</h${level}>`
    );
  }

  const headingsArray = Object.values(headings).map(heading => {
    if (heading.subheadings.length > 0) {
      heading.subheadings = Object.values(heading.subheadings);
    }
    return heading;
  });

  return { headings: headingsArray, htmlWithIds };
}

export function findAndFilterDuplicates(headings) {
  if (headings === undefined) return { duplicates: [], filteredHeadings: [] };
  const seenHeadings = new Set();
  const filteredHeadings = [];

  for (const heading of headings) {
    const textWithoutEntities = heading.text.replace(/&[^\s;]+;/g, '');
    if (!seenHeadings.has(textWithoutEntities)) {
      filteredHeadings.push(heading);
      seenHeadings.add(textWithoutEntities);
    }
  }

  return filteredHeadings;
}

export function scrollToBlogElement(elementId) {
  const element = document.getElementById(elementId);

  if (element) {
    const yOffset = element.getBoundingClientRect().top + window.pageYOffset;
    const targetY = yOffset - 100;

    window.scrollTo({ top: targetY, behavior: 'smooth' });
  }
}

export default getHeadings;
